
import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import SettingsFastBalancesPage, { getDefaultPageData } from "components/pages/SettingsFastBalancesPage";
import Classes from "model";
import "./styles.css";

export default function CaptureFastBalancesSuccess(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const mobileDevice = BCMSDefaultModel.mobileDevice();
    mobileDevice.name = "George's Phone";
    mobileDevice.isEnrolled = true;
    mobileDevice.recentlyEnrolled = true;

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "mobileDevice" ], mobileDevice)
        .submit();

    return <div className="success-007"><SettingsFastBalancesPage data={ data } /></div>;
}